// extracted by mini-css-extract-plugin
export default {"sortableItem":"sortableItem_sortableItem__vIcrv","dragHandle":"sortableItem_dragHandle__mNUpE"};